import React, { useContext, useEffect } from "react";
import { useState } from "react";
import axios from "axios"
import { ItemListResponse } from "helpers/interfaces";
import { IState, ticketsContext } from "views/Tickets/TicketsContext";
import { useLocation } from "react-router-dom";
import { TicketQueue } from "helpers/enums";


interface IContext {
    ticketsDashboard: ITicketsDashboard[]
    usersDashboard: IAssigneeDashboard[]
}

interface ITicketsDashboard {
    status: string
    type: string
    count: number
}

interface IAssigneeDashboard {
    email: string
    assignee: number
    csAssignee: number
}

export let ticketsDashboardContext = React.createContext({} as IContext);

let { Provider } = ticketsDashboardContext;

let TicketsDashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let location = useLocation<IState>()
    let { supplier, setLoading } = useContext(ticketsContext);

    let [ticketsDashboard, setTicketsDashboard] = useState<ITicketsDashboard[]>([]);
    let [usersDashboard, setUserDashboard] = useState<IAssigneeDashboard[]>([]);
    

    useEffect(() => {
        if (location.state.queue === TicketQueue.TicketsDashboard) {
            getTicketsDashboards();
            getAssigneeDashboard();
        }
    }, [supplier])


    let getTicketsDashboards = async () => {
        try {
            let res = await axios.get<ItemListResponse<ITicketsDashboard>>('/api/Ticket/GetTicketsDashboard', { params: { supplier } })
            setTicketsDashboard(res.data.items);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let getAssigneeDashboard = async () => {
        try {
            let res = await axios.get<ItemListResponse<IAssigneeDashboard>>('/api/Ticket/GetAssigneeDashboard', { params: { supplier } })
            setUserDashboard(res.data.items);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                ticketsDashboard,
                usersDashboard,
            }}
        >
            {children}
        </Provider>

    )
}

export default TicketsDashboardProvider

